export default "__VITE_ASSET__BcwnEeNe__"